import { render, staticRenderFns } from "./TemplateCardGlobal.vue?vue&type=template&id=4a8a3a4a&scoped=true&"
import script from "./TemplateCardGlobal.vue?vue&type=script&lang=js&"
export * from "./TemplateCardGlobal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCardGlobal.vue?vue&type=style&index=0&id=4a8a3a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a3a4a",
  null
  
)

export default component.exports